import { useEffect, useState } from 'react'

import type { RefObject } from 'react'

import { TILE_ASPECT } from './gridLayout'

const COVER_TOLERANCE = 0.75

export const useVideoObjectFit = (
  containerRef: RefObject<HTMLElement>,
  trackSid?: string,
  aspect: number = TILE_ASPECT
) => {
  const [objectFit, setObjectFit] = useState<'cover' | 'contain'>('contain')

  useEffect(() => {
    const video = containerRef.current?.querySelector('video')

    if (!video) {
      return
    }

    const measure = () => {
      const { videoWidth, videoHeight } = video

      if (!videoWidth || !videoHeight) {
        return
      }

      setObjectFit(videoWidth / videoHeight >= aspect * COVER_TOLERANCE ? 'cover' : 'contain')
    }

    measure()

    video.addEventListener('loadedmetadata', measure)
    video.addEventListener('resize', measure)

    return () => {
      video.removeEventListener('loadedmetadata', measure)
      video.removeEventListener('resize', measure)
    }
  }, [containerRef, trackSid, aspect])

  return objectFit
}
